<div class="container-cards">
  <ng-content></ng-content>
</div>
